export default __webpack_public_path__ + "static/media/logo.c8a738d5.svg";